import { GlobalAction, UserState } from '.';

const GET_USERS_START = 'GET_USERS_START';
const GET_USERS_ERROR = 'GET_USERS_ERROR';
const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
const GET_USER_START = 'GET_USER_START';
const GET_USER_ERROR = 'GET_USER_ERROR';
const EDIT_USER_START = 'EDIT_USER_START';
const EDIT_USER_ERROR = 'EDIT_USER_ERROR';
const EDIT_USER_SUCCESS = 'EDIT_USER_SUCCESS';
const DELETE_USER_START = 'DELETE_USER_START';
const DELETE_USER_ERROR = 'DELETE_USER_ERROR';
const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
const GET_DEPARTMENTS_START = 'GET_DEPARTMENTS_START';
const GET_DEPARTMENTS_ERROR = 'GET_DEPARTMENTS_ERROR';
const GET_DEPARTMENTS_SUCCESS = 'GET_DEPARTMENTS_SUCCESS';
const ADD_DEPARTMENT_START = 'ADD_DEPARTMENT_START';
const ADD_DEPARTMENT_ERROR = 'ADD_DEPARTMENT_ERROR';
const ADD_DEPARTMENT_SUCCESS = 'ADD_DEPARTMENT_SUCCESS';
const EDIT_DEPARTMENT_START = 'EDIT_DEPARTMENT_START';
const EDIT_DEPARTMENT_ERROR = 'EDIT_DEPARTMENT_ERROR';
const EDIT_DEPARTMENT_SUCCESS = 'EDIT_DEPARTMENT_SUCCESS';
const DELETE_DEPARTMENT_START = 'DELETE_DEPARTMENT_START';
const DELETE_DEPARTMENT_ERROR = 'DELETE_DEPARTMENT_ERROR';
const DELETE_DEPARTMENT_SUCCESS = 'DELETE_DEPARTMENT_SUCCESS';

export const userReducer = (
  state: UserState,
  action: GlobalAction
): UserState => {
  const { payload, type } = action;
  switch (type) {
    case GET_USERS_START:
    case GET_USER_START:
    case DELETE_USER_START: {
      return {
        ...state,
        users: {
          ...state.users,
          loading: true,
        },
      };
    }
    case GET_USERS_ERROR:
    case DELETE_USER_ERROR: {
      return {
        ...state,
        users: {
          ...state.users,
          loading: false,
        },
      };
    }
    case GET_USERS_SUCCESS: {
      return {
        ...state,
        users: {
          items: [...payload.users.items],
          order: [],
          count: payload.count,
          loading: false,
          totalAllowedUsers: payload.totalAllowedUsers,
          totalActiveUsers: payload.totalActiveUsers,
        },
      };
    }
    case GET_DEPARTMENTS_START: {
      return {
        ...state,
        departments: {
          ...state.departments,
          loading: true,
        },
      };
    }
    case GET_DEPARTMENTS_ERROR: {
      return {
        ...state,
        departments: {
          ...state.departments,
          loading: false,
        },
      };
    }
    case GET_DEPARTMENTS_SUCCESS: {
      return {
        ...state,
        departments: {
          items: [...payload.departments.items],
          count: payload.count,
          loading: false,
        },
      };
    }
    default:
      return state;
  }
};

export const USER_ACTIONS = {
  GET_USERS_START,
  GET_USERS_ERROR,
  GET_USERS_SUCCESS,
  GET_USER_START,
  GET_USER_ERROR,
  EDIT_USER_START,
  EDIT_USER_ERROR,
  EDIT_USER_SUCCESS,
  DELETE_USER_START,
  DELETE_USER_ERROR,
  DELETE_USER_SUCCESS,
  GET_DEPARTMENTS_START,
  GET_DEPARTMENTS_ERROR,
  GET_DEPARTMENTS_SUCCESS,
  ADD_DEPARTMENT_START,
  ADD_DEPARTMENT_ERROR,
  ADD_DEPARTMENT_SUCCESS,
  EDIT_DEPARTMENT_START,
  EDIT_DEPARTMENT_ERROR,
  EDIT_DEPARTMENT_SUCCESS,
  DELETE_DEPARTMENT_START,
  DELETE_DEPARTMENT_ERROR,
  DELETE_DEPARTMENT_SUCCESS,
};
